import React from "react";
import { Route } from "react-router-dom";
import { menuConfig } from "../configs/MenuConfig";
import * as SupplierPages from "../pages/supplier";
import SupplierPanel from "../pages/supplier/SupplierPanel";
import SupplierProfileEdit from "../pages/supplier/SupplierProfileEdit";
import ProductCreate from "../pages/supplier/product/ProductCreate";
import ProductEdit from "../pages/supplier/product/ProductEdit";
import PanelLayout from"../layouts/PanelLayout"
import ProtectedRoute from "../components/ProtectedRoute";
import SupplierPDP from "../pages/supplier/product/SupplierPDP";

function renderRoutes(items = []) {
  return items.map(({ link, component, submenu }) => {
    if (link === '/password-setting/') {
      return null;
    }
    const Page = component ? SupplierPages[component] : undefined;

    return (
      <Route key={link} path={link} element={Page ? <Page /> : undefined}>
        {submenu && renderRoutes(submenu)}
      </Route>
    );
  });
}

export default function SupplierRoutes() {
  const routes = menuConfig.supplier.items;

  return (
    <Route path="/supplier-panel" element={<ProtectedRoute allowedRoles={["supplier","admin"]}><PanelLayout user ='supplier'/></ProtectedRoute>}>
      <Route path="supplier-profile-edit" element={<SupplierProfileEdit />} />
      <Route path="supplier-product-create" element={<ProductCreate />} />
      <Route path="supplier-product-edit/:id" element={<ProductEdit />} />
      <Route path="supplier-product/:id" element={<SupplierPDP />} />
     <Route index element={<SupplierPanel />} />
     {renderRoutes(routes)}
    </Route>
);
}